import { fetchListPage, JIVANDHARA_BASE } from "../admin/list-api-helpers";
import { formatPanchangDateKey } from "@project/lib/jain-panchang-utils";
import type { JainPanchang } from "@project/types/jain-panchang";

const BASE = `${JIVANDHARA_BASE}/jain-panchang`;

function filterVisible(items: JainPanchang[]) {
  return items
    .filter(item => item.status && item.show_on_website)
    .sort((a, b) => a.english_date.localeCompare(b.english_date));
}

class PublicJainPanchangService {
  private listAllVisible = async (): Promise<JainPanchang[]> => {
    const result = await fetchListPage<JainPanchang>(`${BASE}/`, {
      page: 1,
      page_size: 200,
    });
    return filterVisible(result.data);
  };

  listForMonth = async (
    year: number,
    month: number
  ): Promise<JainPanchang[]> => {
    const monthPrefix = `${year}-${String(month).padStart(2, "0")}`;
    const visible = await this.listAllVisible();
    return visible.filter(item => item.english_date.startsWith(monthPrefix));
  };

  listHighlights = async (): Promise<{
    today: JainPanchang | null;
    upcoming: JainPanchang[];
  }> => {
    const visible = await this.listAllVisible();
    const todayKey = formatPanchangDateKey(new Date());
    const today = visible.find(item => item.english_date === todayKey) ?? null;
    const upcoming = visible
      .filter(item => item.show_in_upcoming && item.english_date > todayKey)
      .slice(0, 6);

    return { today, upcoming };
  };

  /** Public filter by English calendar date for sponsorship tithi selection. */
  listByEnglishDate = async (englishDate: string): Promise<JainPanchang[]> => {
    const date = englishDate.trim();
    if (!date) {
      return [];
    }
    const result = await fetchListPage<JainPanchang>(`${BASE}/`, {
      page: 1,
      page_size: 20,
      english_date: date,
    });
    return (result.data ?? []).slice().sort((a, b) => {
      const orderDiff = (a.display_order ?? 0) - (b.display_order ?? 0);
      if (orderDiff !== 0) {
        return orderDiff;
      }
      return a.id - b.id;
    });
  };
}

export const publicJainPanchangService = new PublicJainPanchangService();
